import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Paper, Flex, Text, Modal, Pagination } from '@mantine/core'
import { useSelector } from 'react-redux'
import NoData from '../../../ui/NoData'
import LoadingData from '../../../ui/LoadingData'
import TableUserInsightProduct from './Helper/TableUserInsightProduct'
import TableUserCollectorProduct from './Helper/TableUserCollectorProduct'
import { updateExclusiveUser, editProduct, getCollectorDataProduct } from '../../../../services/products'
import { deleteUserProductRecommendation } from '../../../../services/users'
import { modalDeleteDataUsePayload } from '../../../ui/Prompt/modalDeleteDataUsePayload'
import FormAddInsightUserProduct from './Form/FormAddInsightUserProduct'
import { modalDeleteDataUseId } from '../../../ui/Prompt/modalDeleteDataUseId'
import { useDebouncedCallback } from '@mantine/hooks'

const labelTable = [
  {
    label: 'Name',
    width: 300
  },
  {
    label: 'Email',
    width: 300
  },
  {
    label: 'Phone',
    width: 300
  },
  {
    label: 'Member Role',
    width: 300
  },
  {
    label: 'Action',
    width: 50
  },
]

const labelCollectorTable = [
  {
    label: 'Name',
    width: 'auto'
  },
  {
    label: 'Email',
    width: 'auto'
  },
  {
    label: 'Phone',
    width: 'auto'
  },
]

const defaultParamsCollector = {
  'page[num]': 1,
  'page[limit]': 10,
}


const ProductInsights = ({ productId, reloadProduct }) => {
  const { isLoadingProduct, included, minimumPayload } = useSelector(state => state.product_detail)
  const [recommendUser, setRecommendUser] = useState([])
  const [exclusiveUser, setExclusiveUser] = useState([])
  const [ownerUser, setOwnerUser] = useState([])
  const [modalAddUser, setModalAddUser] = useState(false)
  const [stateUser, setStateUser] = useState('')
  const [loadingCollector, setLoadingCollector] = useState(true)
  const [paramsCollector, setParamsCollector] = useState(defaultParamsCollector)
  const [collectorList, setCollectorList] = useState([])
  const [totalDataCollector, setTotalDataCollector] = useState(0)

  const handleGetDataCollectorProduct = useDebouncedCallback(async (idProduct) => {
    setLoadingCollector(true)
    try {
      const response = await getCollectorDataProduct(idProduct, paramsCollector)
      if (response.success) {
        const { data, meta } = response
        const countData = meta.pagination.total
        const remapData = data.map((val) => {
          return {
            id: val.attributes.id,
            name: val.attributes.name,
            email: val.attributes.email,
            phone: val.attributes.phone,
          }
        })
        setCollectorList(remapData)
        setTotalDataCollector(countData)
      } else {
        collectorList([])
        setTotalDataCollector(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCollector(false)
    }
  }, 300)

  // service
  const generatePayload = () => {
    return {
      ...minimumPayload,
    }
  }

  const remapData = (data) => {
    return data.map((val) => {
      const { attributes } = val
      return {
        id: attributes.id,
        name: attributes.name,
        email: attributes.email,
        phone: attributes.phone,
        membership: attributes.membership.name || '-'
      }
    })
  }

  const assignInsightProduct = (included) => {
    const { recommendations, exclusive, owner } = included
    const includedRecommendation = Object.values(recommendations) || []
    const includedExclusive = Object.values(exclusive) || []
    const includedOwner = Object.values(owner) || []

    const remapRecommendUser = remapData(includedRecommendation)
    const remapExclusiveUser = remapData(includedExclusive)
    const remapOwnerUser = remapData(includedOwner)

    setRecommendUser(remapRecommendUser)
    setExclusiveUser(remapExclusiveUser)
    setOwnerUser(remapOwnerUser)
  }

  useEffect(() => {
    if (!isLoadingProduct && included) {
      assignInsightProduct(included)
    }
    // eslint-disable-next-line
  }, [isLoadingProduct, included])

  useEffect(() => {
    if (productId) {
      handleGetDataCollectorProduct(productId)
    }
    // eslint-disable-next-line
  }, [productId, paramsCollector])

  const actions = {
    deleteRecommendUser: (val) => {
      modalDeleteDataUseId('Recomendation User', val.id, productId, val.name, deleteUserProductRecommendation, reloadProduct)
    },
    deleteExclusiveUser: (val) => {
      const dataUser = exclusiveUser
      const filteredUser = dataUser.filter((value) => value.id !== val.id)
      const remapPayload = filteredUser.map((val) => {
        return val.id
      })
      const payload = {
        users: remapPayload
      }
      modalDeleteDataUsePayload('Exclusive User', productId, payload, val.name, updateExclusiveUser, reloadProduct)
    },
    deleteOwnerUser: (val) => {
      const dataUser = ownerUser
      const filteredUser = dataUser.filter((value) => value.id !== val.id)
      const remapPayload = filteredUser.map((val) => {
        return val.id
      })
      const payload = generatePayload()
      payload.user_ids = remapPayload
      modalDeleteDataUsePayload('Item List User', productId, payload, val.name, editProduct, reloadProduct)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalAddUser = () => {
    setModalAddUser(false)
    setStateUser('')
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParamsCollector((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const loadDataUser = (dataUser, deleteState) => {
    if (dataUser.length > 0) {
      return <TableUserInsightProduct label={labelTable} data={dataUser} actionMethod={handleAction} stateDelete={deleteState} />
    } else {
      return <NoData />
    }
  }

  const loadDataCollector = (data) => {
    if (data.length > 0) {
      return <TableUserCollectorProduct label={labelCollectorTable} data={data} />
    } else {
      return <NoData />
    }
  }

  const handleDataUser = (state) => {
    if (state === 'recommendation') {
      return recommendUser
    } else if (state === 'exclusive') {
      return exclusiveUser
    } else if (state === 'owner-list') {
      return ownerUser
    } else {
      return []
    }
  }

  return (
    <Box mb={20} mt={10}>
      <Paper my={'lg'} p={'md'} withBorder shadow="xs" radius="md">
        <Flex justify='space-between' align='center'>
          <Text fw={500}>
            Recomendation Product For ({recommendUser.length})
          </Text>
          <Button size='xs' variant="filled" onClick={() => [setModalAddUser(true), setStateUser('recommendation')]}>Add User</Button>
        </Flex>
        <Divider my={10} />
        <Box my={10}>
          {isLoadingProduct ? <LoadingData /> : loadDataUser(recommendUser, 'deleteRecommendUser')}
        </Box>
      </Paper>
      <Paper my={'lg'} p={'md'} withBorder shadow="xs" radius="md">
        <Flex justify='space-between' align='center'>
          <Text fw={500}>
            Exclusive Product For ({exclusiveUser.length})
          </Text>
          <Button size='xs' variant="filled" onClick={() => [setModalAddUser(true), setStateUser('exclusive')]}>Add User</Button>
        </Flex>
        <Divider my={10} />
        <Box my={10}>
          {isLoadingProduct ? <LoadingData /> : loadDataUser(exclusiveUser , 'deleteExclusiveUser')}
        </Box>
      </Paper>
      <Paper my={'lg'} p={'md'} withBorder shadow="xs" radius="md">
        <Flex justify='space-between' align='center'>
          <Text fw={500}>
            Added to my item list by ({ownerUser.length})
          </Text>
          <Button size='xs' variant="filled" onClick={() => [setModalAddUser(true), setStateUser('owner-list')]}>Add User</Button>
        </Flex>
        <Divider my={10} />
        <Box my={10}>
          {isLoadingProduct ? <LoadingData /> : loadDataUser(ownerUser, 'deleteOwnerUser')}
        </Box>
      </Paper>
      <Paper my={'lg'} p={'md'} withBorder shadow="xs" radius="md">
        <Text fw={500}>
          Added to My Channel Platform ({collectorList.length})
        </Text>
        <Divider my={10} />
        <Box my={10}>
          {loadingCollector ? <LoadingData /> : loadDataCollector(collectorList)}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} value={paramsCollector['page[num]']} total={totalDataCollector > 0 ? Math.ceil(totalDataCollector / paramsCollector['page[limit]']) : totalDataCollector} />
        </Flex>
      </Paper>
      <Modal opened={modalAddUser} onClose={onCloseModalAddUser} centered closeOnClickOutside={false} size='30%' title={<Text fw='Bold' tt='capitalize'>Add User</Text>} withCloseButton={false}>
        <FormAddInsightUserProduct idProduct={productId} userState={stateUser} dataRecentUser={handleDataUser(stateUser)} onCloseForm={onCloseModalAddUser} reloadDetail={reloadProduct} />
      </Modal>
    </Box>
  )
}

export default ProductInsights